import styled from '@emotion/styled';
import React from 'react';
import { i18n } from 'src/common';
import { BarCode, Flex, Text } from 'src/components';
import { colors } from 'src/theme';
import { GeneralTransferDetailsDto } from 'src/common/api/apollo/types/types';

const Container = styled.div({
  backgroundColor: colors.white,
  borderRadius: 12,
  border: `1px solid ${colors.border6}`,
  overflow: 'hidden',
});

const Header = styled(Flex)({
  backgroundColor: colors.primary,
  padding: '20px 48px',
});

const HeaderText = styled(Text)({
  color: colors.white,
});

const Content = styled(Flex)({
  padding: 12,
});

export interface BarcodeCardProps {
  title?: string;
  data: Partial<GeneralTransferDetailsDto>;
  paymentType: 'oneTime' | 'installments';
}

const formatBarcodePrice = (price: number): string =>
  price.toFixed(2).replace('.', ',');

export const BarcodeCard: React.FC<BarcodeCardProps> = ({
  title = i18n.t('components.cards.barcodeCard.title'),
  data,
  paymentType,
}) => {
  const displayPrice = data.price != null
    ? (paymentType === 'oneTime' ? data.price : data.price / 12)
    : 0;

  return (
    <Container>
      <Header align="center" justify="space-between" wrap="wrap">
        {title && <HeaderText type="small" bold>{title}</HeaderText>}
        {data.price != null && (
          <HeaderText type="medium" bold>
            {`${displayPrice.toFixed(2)}€`}
          </HeaderText>
        )}
      </Header>
      <Content align="center" justify="center">
        <BarCode
          price={formatBarcodePrice(displayPrice)}
          userFirstName={data.customerFirstName ?? ''}
          userLastName={data.customerLastName ?? ''}
          userAddress={data.customerAddress ?? ''}
          userCity={data.customerCity ?? ''}
          oib={data.customerOib ?? '0'}
          recipient={data.recipientName ?? ''}
          recipientAddress={data.recipientAddress ?? ''}
          recipientCity={data.recipientCity ?? ''}
          model={data.model ?? ''}
          iban={data.recipientAccountNumber ?? ''}
          description={data.description ?? ''}
          hidden={false}
        />
      </Content>
    </Container>
  );
};
